import { cn } from '../../lib/cn.ts';

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} aria-hidden="true" />;
}

/** Full-area loading state, announced to screen readers. */
export function Loading({ label = 'Cargando…' }: { label?: string }) {
  return (
    <div role="status" className="flex items-center gap-3 p-6 text-sm text-muted-foreground">
      <span
        className="size-5 animate-spin rounded-full border-2 border-primary border-t-transparent"
        aria-hidden="true"
      />
      {label}
    </div>
  );
}
